export default "__VITE_PUBLIC_ASSET__c5df413d__"